import { memo } from 'react';
import Link from './Link';

export default memo(Link);
